import ar from '@/local/ar.js';
import HomePage from '../pages/home-page.vue';
import NewComplaintPage from '../pages/new-complaint-page.vue';
import Profile from '@/modules/complaints/components/profile/index.vue';

export default [
  {
    path: '/',
    name: 'homePage',
    component: HomePage,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.mainPage,
        isDynamic: false,
      },
    },
  },
  {
    path: '/complaint',
    name: 'newComplaint',
    component: NewComplaintPage,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.newComplaints,
        isDynamic: false,
      },
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.profilePage,
        isDynamic: false,
      },
    },
  },
];
